module.exports = __webpack_public_path__ + "img/zengzhi.0593a648.png";